// Sun/moon theme toggle. Renders BOTH icons; which one shows is decided
// purely in CSS off `html[data-theme]` (see index.css), so the markup is
// identical on the server pre-render and the client — no hydration
// mismatch. The click flips the theme via the store.

import { useThemeStore } from "@/stores/themeStore";

export function ThemeToggle({ className = "" }: { className?: string }) {
  const toggle = useThemeStore((s) => s.toggle);

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Toggle light/dark theme"
      title="Toggle theme"
      className={
        "inline-grid place-items-center w-[34px] h-[34px] rounded border border-stroke text-muted " +
        "hover:text-content hover:border-accent transition-colors shrink-0 " +
        className
      }
    >
      {/* shown in dark mode → click to go light */}
      <svg
        className="theme-ico-sun w-[17px] h-[17px]"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8" />
        <path
          d="M12 2v2.4M12 19.6V22M4.5 4.5l1.7 1.7M17.8 17.8l1.7 1.7M2 12h2.4M19.6 12H22M4.5 19.5l1.7-1.7M17.8 6.2l1.7-1.7"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
      {/* shown in light mode → click to go dark */}
      <svg
        className="theme-ico-moon w-[17px] h-[17px]"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
